import { Pressable, View } from "react-native";
import { IAllowScheduledOrdersOption } from "../../../../types/agent-settings";
import { useSettingsData } from "../../../../contexts/SettingsDataContext";
import StyledText from "../../../common/ui/styled-text";
import { Check } from "lucide-react-native";

interface IAllowScheduledOrdersCard {
  id: Exclude<IAllowScheduledOrdersOption, "never">;
  label: string;
  description: string;
}

interface AllowScheduledOrdersSelectorProps {
  selectedOption: IAllowScheduledOrdersOption;
  onSelect: (optionId: IAllowScheduledOrdersOption) => void;
}

const options: IAllowScheduledOrdersCard[] = [
  {
    id: "normal",
    label: "Business hours only",
    description:
      "Scheduled orders can be placed during normal operating hours only.",
  },
  {
    id: "morning",
    label: "Business hours & pre-opening",
    description:
      "Scheduled orders can be placed during normal operating hours or before the restaurant opens, starting at 5am.",
  },
  {
    id: "always",
    label: "24/7",
    description: "Accept scheduled orders at all times.",
  },
];

const AllowScheduledOrdersSelector = ({
  selectedOption,
  onSelect,
}: AllowScheduledOrdersSelectorProps) => {
  const { isTestCallActive } = useSettingsData();

  return (
    <View className="space-y-3">
      {options.map((option) => (
        <Pressable
          key={option.id}
          onPress={() => onSelect(option.id)}
          className={`p-2 rounded-lg border ${
            selectedOption === option.id
              ? "border-gray-700 bg-gray-50"
              : "border-gray-300 bg-white"
          }`}
          disabled={isTestCallActive}
        >
          <View className="flex-row justify-between items-center">
            <View className="flex-1 min-w-0 pr-8">
              <StyledText className="font-medium text-sm">
                {option.label}
              </StyledText>
              <StyledText className="text-[13px] leading-[18px] text-gray-500 mt-1">
                {option.description}
              </StyledText>
            </View>

            <View className="flex-shrink-0 w-5">
              {selectedOption === option.id && <Check size={20} color="#111" />}
            </View>
          </View>
        </Pressable>
      ))}
    </View>
  );
};

export default AllowScheduledOrdersSelector;
